<template>
  <div class="cancellation-request-modal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Gerar link para pagamento de assinatura</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div v-if="!checkoutLink" class="row">
          <div class="col-12">
            <div class="card-select-title mb-2">Selecione o plano:</div>

            <b-field>
              <b-select
                required
                v-model="selectedPlan"
                placeholder="Selecione..."
              >
                <b-select-option :value="null">Selecionar</b-select-option>

                <b-select-option
                  v-for="(plan, idx) in plans"
                  :value="plan.id"
                  :key="idx"
                >
                  {{ plan.name }} - {{ plan.value | currency("BRL") }} - {{ plan.schedules_limit }} Créditos
                </b-select-option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12">
            <b-button class="btn-copy remove-focus w-100" @click="onCopyText" icon-right="copy">
              {{ checkoutLink }}
            </b-button>
          </div>
        </div>
      </section>
      <footer  class="modal-card-foot">
        <b-button
          v-if="!checkoutLink"
          @click="generateLink()"
          :loading="isLoading"
          :disabled="isLoading"
          type="is-primary"
          expanded
        >
          Gerar link
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import SubscriptionService from "@/services/subscriptions.service";

export default {
  components: {},
  props: {
    lawyer_id: {
      type: Number,
      default: () => null,
    },
  },
  data: () => ({
    plans: [],
    isLoading: false,
    selectedPlan: null,
    checkoutLink: null,
  }),
  computed: {},
  methods: {
    loadPlans() {
      this.isLoading = true;

      SubscriptionService.getPlans()
        .then(({ data }) => (this.plans = data))
        .catch(() => {
          this.$buefy.snackbar.open(
            "Erro ao carregar planos de assinaturas. Tente novamente."
          );
        })
        .finally(() => (this.isLoading = false));
    },
    generateLink() {
      this.isLoading = true;

      const data = {
        lawyer_id: this.lawyer_id,
        plan_id: this.selectedPlan,
      };

      SubscriptionService.generateCheckoutLink(data)
        .then(({ data }) => (this.checkoutLink = data.action_url))
        .catch(() => {
          this.$buefy.snackbar.open(
            "Erro ao gerar link de pagamento. Tente novamente."
          );
        })
        .finally(() => (this.isLoading = false));
    },

    async onCopyText() {
      await window.navigator.clipboard.writeText(this.checkoutLink);
      this.toast("Código copiado para área de transferência", "is-success");
    },
  },
  beforeMount() {
    this.loadPlans();
  },
};
</script>

<style lang="scss" scoped></style>
